import { addLoader } from './loader'

export const EMBED_IFRAME_SANDBOX =
  'allow-scripts allow-forms allow-same-origin allow-popups allow-popups-to-escape-sandbox allow-downloads'

export const createIframeWithLoader = (container: HTMLElement) => {
  const loader = addLoader(container)
  const iframe = document.createElement('iframe')
  iframe.allow = 'clipboard-write'
  iframe.title = 'XUND Health Check'
  iframe.setAttribute('sandbox', EMBED_IFRAME_SANDBOX)
  iframe.style.width = '100%'
  iframe.style.height = '100%'
  iframe.style.border = 'none'

  container.appendChild(iframe)
  return { iframe, loader }
}
